import gql from 'graphql-tag';

import DAILY_SUMMARY_FRAGMENT from './DAILY_SUMMARY_FRAGMENT';

export const GET_SERVICE_RUNS_DAILY_SUMMARY = gql`
	query(
		$page: Int,
		$perPage: Int,
		$sortBy: String,
		$sortDirection: Int,
		$filter: ServiceRunPageFilter
	) {
		getServiceRuns(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				...serviceRunsDailySummary
			}
			count
		}
	}
	${DAILY_SUMMARY_FRAGMENT}
`;

export default GET_SERVICE_RUNS_DAILY_SUMMARY;
